import { isPlainObject } from "@next-platform/packages-ts-types";
function isPlainValueEqual(first, second) {
    if (Object.is(first, second)) {
        return true;
    }
    if (Array.isArray(first) && Array.isArray(second)) {
        return first.length === second.length && first.every((element, index) => isPlainValueEqual(element, second[index]));
    }
    if (isPlainObject(first) && isPlainObject(second)) {
        const firstKeys = Object.keys(first);
        return firstKeys.length === Object.keys(second).length && firstKeys.every((key) => key in second && isPlainValueEqual(first[key], second[key]));
    }
    return false;
}
/**
 * Structural equality for resolved page blocks. Blocks are built exclusively
 * by `resolvePageConfiguration` from validated plain JSON (optional keys are
 * omitted, never `undefined`), so generic recursion stays exact as the block
 * shape grows instead of silently ignoring future fields.
 */
export default function areResolvedPageBlocksEqual(first, second) {
    return isPlainValueEqual(first, second);
}
